import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".splide")) {
    const splide = new Splide(".splide", {
      type: "loop",
      focus: "center",
      arrows: true,
      perPage: 7,
      perMove: 1,
      pagination: false,
      gap: "1rem",
      width: "100%",
      breakpoints: {
        375: {
          perPage: 3,
        },
        475: {
          perPage: 3,
        },
        1000: {
          perPage: 5,
        },
        1200: {
          perPage: 5,
        },
        1440: {
          perPage: 6,
        },
      },
    });

    splide.on("mounted", function () {
      document.querySelector(".splide").style.visibility = "visible";
    });

    splide.mount();
  }
});
